export const orders = {
    ascOrder: 'asc',
    descOrder: 'desc',
    noOrder: null,
}
